import { unblockSlotsApi as generatedUnblockSlotsApi } from '../generated/slots/unblockSlots';

import { getSlotsByDayApi } from './getSlotsByDay';

const unblockSlotsApi = generatedUnblockSlotsApi.enhanceEndpoints({
  endpoints: {
    unblockSlots: {
      invalidatesTags: (result) => result?.updated.map(({ date }) => ({ id: date, type: 'Slots' as const })) ?? [],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        for (const { date } of data.updated) {
          dispatch(
            getSlotsByDayApi.util.updateQueryData('getSlotsByDay', { date }, (draft) => {
              for (const slot of draft.slots) {
                if (body.idSlots.includes(slot.slotId) && slot.type === 'blockedSlot') {
                  Object.assign(slot, { type: 'freeSlot' });
                }
              }
            }),
          );
        }
      },
    },
  },
});

export const { useUnblockSlotsMutation } = unblockSlotsApi;
